export function queryString(key = '', arg = '', append = false) {
  if (key.length > 0) {
    const url = new URL(location.href);

    if (arg.length > 0) {
      url.searchParams[append ? 'append' : 'set'](key, arg);
    } else {
      url.searchParams.delete(key);
    }

    history.replaceState({}, '', url.href);
  }
}
